import { getFromlocalstorage } from "../MaHoaDuLieu/MaHoaDuLieu";

const CheckCrypto = async (navigate, setMethod, showNotify) => {
  const data = JSON.parse(getFromlocalstorage("data_u"));
  const apiUrl = process.env.REACT_APP_API_BACKEND;

  // check thiết bị
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  try {
    const response = await fetch(`${apiUrl}/kiemtramkbankcrypto/${data._id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: data._id }),
    });

    const result = await response.json();

    if (result.crypto) {
      if (isMobile) {
        // mobile → navigate
        navigate("/addtkrutmobile");
      } else {
        // desktop → show notify
        showNotify("Vào cập nhật ví crypto để rút tiền!", "error");
      }
    } else if (response.ok && result.success === "thành công") {
      setMethod("usdt");
    }
  } catch (error) {
    console.error("Lỗi API kiểm tra tài khoản:", error);
    showNotify("Có lỗi khi kiểm tra tài khoản crypto!", "error");
  }
};

export default CheckCrypto;
